export const LINK = 'link';
export const BOLD = 'bold';
export const ITALIC = 'italic';
